/**
 * AWS Cognito configuration for production
 * passwordPolicy must match your Cognito User Pool's password policy
 */
export default {
  useCognitoAuth: true,
  userPoolId: 'us-east-1_uVJDIAxGE',
  clientId: '4k84d52lk3a9n1gq528q52qnbl',
  region: 'us-east-1',
  passwordPolicy: {
    minLength: 8,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSymbolsOrSpace: true,
    noLeadingTrailingSpace: true
  }
}
